import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
const Hatimg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/introduce-hat.ec61ec7062161d785e22.png`;
// const Mapimg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/hat-global-map.0c7670e3e201c2020495.png`;
import Mapimg from "../../assets/Introduce/hat-global-map.png";
import HatPageTopLine from "../../Component/HatPageTopLine.js";


const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"사업개요"} titleeng={"Company Profile"} />
            <div className="page-text">
              <div className="kor">
                영안모자는 1959년 설립된 세계적인 모자 생산 및 판매
                기업으로, 글로벌 본사는 <br />
                대한민국 경기도 부천에 위치해 있으며, 전 세계 법인들의 생산과
                판매, <br />
                디자인을 총괄 조정ㆍ지원하는 역할을 수행하고 있습니다. <br />
                영안모자는 지난 65년간, 전 세계에 생산 및 판매법인을 지속적으로{" "}<br />
                설립하여 글로벌 네트워크를 확대, 구축해왔습니다.<br />
                현재 전 세계 7개국에서 미국, 스리랑카, 방글라데시,베트남 등 6개의<br />
                생산공장과 미국, 캐나다, 호주 등 6개 판매법인을 운영하고 있습니다.
              </div>
              <div className="eng">
                YoungAn Hat is a global headwear manufacturer and supplier established in 1959. <br />
                The Global Headquarter is located in Bucheon, Gyeonggi-do, South Korea, and takes the role <br />
                of coordinating and supporting the overall production, sales, and design of affiliates
                worldwide.
                <br />
                For the last 67 years since the foundation, it has continued to expand and
                build a global network
                <br />
                by establishing production and sales affiliates worldwide. Presently,
                YoungAn Hat operates its
                <br />
                businesses in 7 countries worldwide. There are a total of 6
                factories in U.S.A.,
                <br />
                Sri Lanka, Bangladesh, Vietnam, and etc., and 6 sales
                affiliates in U.S.A., Canada, Australia, and etc. 
              </div>
              <img src={Hatimg} className="hat-img" alt="" />
            </div>

            <PageTitle titleko={"사업자 현황"} titleeng={"Global Network"} />
            <div className="page-text">
              <div className="kor">
                미국 (달라스, 벤톤빌, 스탁톤), 캐나다(몬트리올, 토론토, 밴쿠버), 호주,
                <br />
                한국, 베트남, 방글라데시, 스리랑카
              </div>
              <div className="eng">
                U.S.A (Dallas, Bentonville, Stockton), Canada(Montreal, Toronto, Vancouver), Australia,
                <br />
                Korea, Vietnam, Bangladesh, Sri Lanka
              </div>


            </div>
            <img className="fullsize-map" src={Mapimg} alt="" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
